import * as React from 'react';
import styled from '../../styles/styled-components';
import { Paper } from '../paper';

export interface OverlayPanelProps {
  children: React.ReactChild | React.ReactChild[];
}

export const OverlayPanel: React.SFC<OverlayPanelProps> = ({
  children,
  ...rest
}) => {
  let visible = true;
  if (!children || React.Children.count(children) === 0) visible = false;

  return (
    <Panel visible={visible} {...rest}>
      {children}
    </Panel>
  );
};

const Panel = styled<{ visible: boolean }>(({ visible, ...rest }) => (
  <Paper {...rest} />
))`
  position: fixed;
  right: 50px;
  bottom: 50px;
  z-index: 1;
  transition: opacity 1s;
  opacity: ${p => (p.visible ? 1 : 0)};
`;
